import { CurrencyCode } from "generated/dist/carrier/types";
import { CASH } from "./strings";

/* eslint-disable turbo/no-undeclared-env-vars */
export const IS_SSR = typeof window === "undefined";

export const MAP_DOMAIN_TO_API_KEY = {
  "prex.com.ua": "beta_4gjiTJHF1lM00cLYHBm/YUtueqyxYh5rZ38XYpuiZc0=",
};

export const API_URL = process.env.NEXT_PUBLIC_API_URL as string;
export const IS_DEV = process.env.NODE_ENV === "development";
export const IS_BETA = API_URL.includes("beta") && !IS_DEV;
export const IS_PRODUCTION = !IS_BETA && !IS_DEV;

export const GOOGLE_MAPS_API = process.env
  .NEXT_PUBLIC_GOOGLE_MAPS_API as string;

export const PREXSELL_ORIGIN = "https://prexsell.com";

export const DEFAULT_LANGUAGE = "uk";
export const DEFAULT_PASSENGERS_QTY = 1;
export const DATE_VALUE_FORMAT = "DD-MM-YYYY";
export const TAB_DATE_LABEL_FORMAT = "dd, D";
export const DATE_LABEL_FORMAT = "dd, D MMM";
export const DATE_TIME_LABEL_FORMAT = "DD-MM-YYYY HH:mm";
export const COORDS_DATE_TIME_LABEL_FORMAT = "HH:mm DD-MM-YYYY ";

export const DEFAULT_CURRENCY = CurrencyCode.Uah;

export const SESSION_STORAGE_SEARCH_VALUES_KEY = "__searchValues__";

const Benefits1Icon = "/static/images/icons/filter.svg";
const Benefits2Icon = "/static/images/icons/like.svg";
const Benefits3Icon = "/static/images/icons/coins.svg";
const Benefits4Icon = "/static/images/icons/headset.svg";

export const BENEFITS = [
  {
    iconUrl: Benefits1Icon,
    title: "Зручне користування",
    desc: "Безкоштовна бронь та гнучке управління квитками.",
  },
  {
    iconUrl: Benefits2Icon,
    title: "Якісний сервіс",
    desc: "Ми працюємо для Вас на ринку автобусних перевезень вже більше 20 років.",
  },
  {
    iconUrl: Benefits3Icon,
    title: "Гнучка система знижок",
    desc: "Для наших постійних пасажирів ми завжди готові запропонувати привабливі знижки",
  },
  {
    iconUrl: Benefits4Icon,
    title: "Служба допомоги",
    desc: "На любому етапі допоможемо вирішити будь яке питання клієнта.",
  },
];

const PROD_GATEWAY = "https://prexsell-production.infura-ipfs.io/ipfs/";
const STAGE_GATEWAY = "https://prexsell-staging.infura-ipfs.io/ipfs/";

export const INFURA_IPFS_GATEWAY = IS_PRODUCTION ? PROD_GATEWAY : STAGE_GATEWAY;

export const SESSION_PASSENGER = "__passenger__";

export const PHONE_MIN_LENGTH = 9;
export const REGULAR_PASSENGER_DISCOUNT = 0.9;
export const DEFAULT_PAYMENT_METHOD = CASH;

export const LIQPAY_FORM_ACTION_URL = "https://www.liqpay.ua/api/3/checkout";
export const LIQPAY_VERSION = 3;
export const LIQPAY_COMMISSION = 0.015;
export const LIQPAY_ACTION = "pay";
export const LIQPAY_SERVER_URL = `${API_URL.replace(
  "/graphql/carrier",
  ""
)}/payment/liqpayResponse`;
